import React from "react";
import StudioField from "./StudioField";

export const maxImageTextLength = 90;
const maxFeaturedProducts = 4;

// Optional image direction shared by the AI studios: exact headline text (rendered by the server, so it is
// spelled exactly as typed) and which saved products the visual should feature.
const ImageDirectionFields = ({ products = [], value, onChange, idPrefix }) => {
  const selected = value.products || [];
  const named = products.filter((product) => product.name);
  const toggle = (name) => onChange({
    products: selected.includes(name) ? selected.filter((item) => item !== name) : [...selected, name].slice(0, maxFeaturedProducts)
  });

  return <>
    <StudioField label="Text on image (optional)" wide hint={`${(value.overlayText || "").length}/${maxImageTextLength} · Added exactly as typed. Leave empty for a clean photo.`}>
      <input id={`${idPrefix}-overlay`} className="form-control" maxLength={maxImageTextLength} value={value.overlayText || ""} onChange={(event) => onChange({ overlayText: event.target.value })} placeholder="e.g. Fresh celebration cakes, baked daily" />
    </StudioField>
    {named.length > 0 && <fieldset className="studio-chip-group is-wide">
      <legend>Feature products (optional)</legend>
      <div>{named.map((product) => <button key={product.name} type="button" className={`studio-chip${selected.includes(product.name) ? " is-active" : ""}`} aria-pressed={selected.includes(product.name)}
        disabled={!selected.includes(product.name) && selected.length >= maxFeaturedProducts} onClick={() => toggle(product.name)}>
        {product.hasImage && <i className="ti ti-photo" aria-hidden="true" />}{product.name}
      </button>)}</div>
      <small className="studio-field-hint">Photos from your Business Profile are used as exact references. Without a choice, products named in the prompt are used.</small>
    </fieldset>}
  </>;
};

export default ImageDirectionFields;
